import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

import { push } from "react-router-redux";

function* handleMenu(action) {
  const { close, path } = action.meta;
  if (close) {
    yield put({ type: ACTIONS.CLOSE_MENU });
  }
  if (path) {
    yield put(push(path));
  }
}

export function* menuWatcher() {
  yield takeEvery(ACTIONS.HIT_MENU, handleMenu);
}



// WEBPACK FOOTER //
// ./src/sagas/menu.js